import React from "react"
import { useAuthContext } from "../../Hooks/useAuthContext"

import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import logo from "../../Images/logo.png"

export default function TopNav({  }) {
  const { user, dispatch } = useAuthContext()
  const navigate = useNavigate()



  return (
    <Navbar collapseOnSelect expand="lg" bg="white" variant="light" sticky="top">
      <Container className="container-fluid">
        <NavLink to="/" className="navbar-brand">
            <img src={logo} alt="EcoProspects Logo" style={{ height: "100px" }} />
        </NavLink>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          {user && (
            <>
              <Nav className="me-auto noprint">
                <NavLink className="nav-link" to="/">
                    Home
                </NavLink>
                <NavLink className="nav-link" to="/Farms">
                    Farms
                </NavLink>
                <NavLink className="nav-link" to="/Projects">
                    Projects
                </NavLink>
                <NavLink className="nav-link" to="/Users">
                    Users
                </NavLink>
                <NavLink className="nav-link" to="/Calendar">
                    Calendar
                </NavLink>
              </Nav>
              <Nav className="noprint">
                <Nav.Link
                  onClick={() => {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                  }}
                >
                  Log Out
                </Nav.Link>
                              <NavLink className="nav-link" to={"/Users/View/" + user.id }>
                  {user.name}
                </NavLink>
                
              </Nav>
            </>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
